/**
 * @param {number} seat 0..3
 * @returns {0|1}
 */
function teamOfSeat(seat) {
  const s = Number(seat);
  return s === 0 || s === 2 ? 0 : 1;
}

/**
 * @param {number} seat
 * @returns {0|1}
 */
function playerIndexForSeat(seat) {
  const s = Number(seat);
  return s === 0 || s === 2 ? 0 : 1;
}

module.exports = {
  teamOfSeat,
  playerIndexForSeat,
};
